import { ref } from 'vue'

export const selectionsBus = ref<{ [key: string]: any }[]>([])
